export default __webpack_public_path__ + "static/media/5.a63618f5.jpg";